import { parse } from "graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { GraphqlClient } from "../../../common/GraphqlClient";

export interface ChecklistForEquipment {
  url: string | null;
  fileName: string | null;
  fileId: string | null;
  documentType: "LINK" | "FILE";
  description: string;
  createdAt: number;
  createdBy: string;
}

export interface GetChecklistsForEquipmentInput {
  site: string;
  group: string;
  model: string;
}

interface GetChecklistsForEquipmentResult {
  items: ChecklistForEquipment[];
}

const GET_CHECKLISTS_FOR_EQUIPMENT_QUERY: TypedDocumentNode<
  GetChecklistsForEquipmentResult,
  { input: GetChecklistsForEquipmentInput }
> = parse(`
  query getChecklistsForEquipment($input: GetChecklistsForEquipmentInput) {
    getChecklistsForEquipment(input: $input) {
      items {
        url
        fileName
        fileId
        documentType
        description
        createdAt
        createdBy
      }
    }
  }
`) as unknown as TypedDocumentNode<GetChecklistsForEquipmentResult, { input: GetChecklistsForEquipmentInput }>;

export const getChecklistsForEquipment = async (
  client: GraphqlClient,
  input: GetChecklistsForEquipmentInput
): Promise<ChecklistForEquipment[]> => {
  const result = await client.query(GET_CHECKLISTS_FOR_EQUIPMENT_QUERY, { input });
  return result?.items ?? [];
};
